import ProductLandingTemplate from "./ProductLandingTemplate";

const product = {
  slug: "babavaro-hitel",
  name: "Babaváró hitel",
  description:
    "Ismerd meg a jogosultsági feltételeket, és számold ki, hogyan alakulhat a törlesztésed különböző élethelyzetekben.",
  highlights: [
    "Jogosultsági feltételek könnyen átláthatóan",
    "Támogatási előnyök és buktatók egy helyen",
    "Szakértői segítség az ügyintézés során",
  ],
};

export default function BabavaroPage() {
  return (
    <ProductLandingTemplate
      product={product}
      iframeSrc="https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel"
    />
  );
}
